<div class="modalReauth">
  <div class="modalOverlay" (click)="onCancel()"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <h5 class="modalContentTitle">
        SMS再認証
      </h5>
      <form #reauthForm="ngForm" (ngSubmit)="onSubmit()" class="form">
        <div class="inputContainer">
          <label>
            <div class="inputInnerContainer">
              <div class="inputLabelText">パスコード(6ケタ)</div>
              <input
                class="input text-right"
                type="text"
                name="verificationCode"
                [(ngModel)]="verificationCode"
                #code="ngModel"
                minlength="6"
                maxlength="6"
                pattern="[0-9]+"
                required
              />
            </div>
            <div
              class="inputError"
              *ngIf="code.invalid && (code.dirty && code.touched)"
            >
              ※入力エラー
            </div>
          </label>
        </div>

        <div
          *ngIf="queries.errorMessage$ | async as errorMessage"
          class="errorMessageContainer"
        >
          {{ errorMessage }}
        </div>

        <div class="resendSMSContiner">
          <a (click)="resendSMS()">もう一度、認証用SMSを送信する</a>
        </div>

        <app-sms-notification></app-sms-notification>

        <div [id]="recaptchaContainer"></div>

        <div class="containerBottom">
          <div class="buttonContainer">
            <button
              type="submit"
              [disabled]="reauthForm.form.invalid"
              class="buttonSubmit"
            >
              <span *ngIf="reauthForm.form.invalid"
                >パスコードを入力してください</span
              >
              <span *ngIf="reauthForm.form.valid">認証を行う</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-loading-modal
  [show]="queries.loading$ | async"
></app-loading-modal>
